import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonContactRequestGridPart } from '../../../../../ui/widget';
import { VolunteeringEngagementsService } from '../../volunteering-engagements.service';

@Component({
	selector: 'volunteering-contact-requests-view-part',
	standalone: true,
	imports: [CommonContactRequestGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './contact-requests.part.html',
})
export class ContactRequestsViewPart {
	public readonly pageService = inject(VolunteeringEngagementsService);
	public contactRequests = computed(() => (this.pageService.contactRequests() || []));
}